// kpis
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/tiktok/avgEngagementRateHistory';
import { commentsHistoryConfig } from '@/lib/analytics/charts/tiktok/commentsHistory';
import { followerGrowthConfig } from '@/lib/analytics/charts/tiktok/followerGrowthHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/tiktok/likesHistory';
import { postDensityConfig } from '@/lib/analytics/charts/tiktok/postDensity';
import { postHistoryConfig } from '@/lib/analytics/charts/tiktok/postHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/tiktok/sharesHistory';
// Charts
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/tiktok/videoViewsHistory';
import { avgEngagementRatePerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgEngagementRatePerVideo';
import { avgReachPerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgReachPerVideo';
import { avgReachRatePerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgReachRatePerVideo';
import { avgViewsRatePerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgViewsRatePerVideo';
import { profileViewsConfig } from '@/lib/analytics/kpis/tiktok/profileViews';
import { totalCommentsReceivedConfig } from '@/lib/analytics/kpis/tiktok/totalComments';
import { totalEngagementConfig } from '@/lib/analytics/kpis/tiktok/totalEngagement';
import { totalFollowersConfig } from '@/lib/analytics/kpis/tiktok/totalFollowers';
import { tiktokLikeConfig } from '@/lib/analytics/kpis/tiktok/totalLikes';
import { totalSharesConfig } from '@/lib/analytics/kpis/tiktok/totalShares';
import { videosConfig } from '@/lib/analytics/kpis/tiktok/totalVideos';
import { totalViewsConfig } from '@/lib/analytics/kpis/tiktok/totalViews';
import { videoViewsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/tiktok/videoViewsAvgTimeWatched';
import { videoViewsTotalTimeConfig } from '@/lib/analytics/kpis/tiktok/videoViewsTotalTimeConfig';
//widget
import { mostRecentVideosConfig } from '@/lib/analytics/widget/tiktok/mostRecentVideosConfig';

export const OverviewTiktokBusiness = [
    // Kpis
    totalFollowersConfig,
    videosConfig,
    totalViewsConfig,
    tiktokLikeConfig,

    videoViewsTotalTimeConfig,
    videoViewsAvgTimeWatchedConfig,
    avgViewsRatePerVideoConfig,
    avgEngagementRatePerVideoConfig,

    followerGrowthConfig,
    avgEngagementRateHistoryConfig,

    // Module of the most recent videos missing
    mostRecentVideosConfig,

    totalEngagementConfig,
    totalCommentsReceivedConfig,
    totalSharesConfig,

    avgReachPerVideoConfig,
    avgReachRatePerVideoConfig,
    profileViewsConfig,

    // Chart
    videoViewsHistoryConfig,
    likesHistoryConfig,
    commentsHistoryConfig,
    sharesHistoryConfig,
    postHistoryConfig,
    postDensityConfig
];

export const requestTiktokBusinessParams = [
    [
        'videos',
        'views',
        'engagement',
        'average_engagement_rate_per_views',
        'likes',
        'comments',
        'shares',
        'average_engagement_rate_per_video',
        'average_views_rate_per_video'
    ],
    [
        'total_time_watched',
        'average_time_watched',
        'followers',
        'followers_growth',
        'average_reach_per_video',
        'average_reach_rate_per_video',
        'profile_views'
    ],
    [
        'video_views_history',
        'likes_history',
        'comments_history',
        'shares_history',
        'posts_history',
        'posts_density',
        'average_engagement_rate_history'
    ]
];

export const requestTiktokBusinessOtherParameters = {
    posts_density: {
        type: postDensityConfig.defaultFilter
    }
};
